import LazyString from './lazy-string';
import i18n from './i18n';

/**
 * @deprecated
 * @param key
 */
export function lazyGettext(key: string): LazyString {
  return new LazyString(() => i18n.t(key));
}
